// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__7nNih","breadcrumbs":"Header_breadcrumbs__ev45z","logo":"Header_logo__gECVj","profile":"Header_profile__Nuv11"};